import React from 'react';

const PedidoFilterBar = ({ filters, onChange, searching, extensoes = [], onExtensaoSearch }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-2 mb-4 w-full max-w-full">
      <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 w-full">
        <select
          name="status"
          value={filters.status}
          onChange={onChange}
          className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
        >
          <option value="">Todos os Status</option>
          <option value="Rascunho">Rascunho</option>
          <option value="Pendente">Pendente</option>
          <option value="Concluido">Concluído</option>
          <option value="Cancelado">Cancelado</option>
        </select>
        <div className="relative">
          <input
            type="text"
            name="extensaoSearch"
            placeholder="Buscar Extensão..."
            value={filters.extensaoSearch || ''}
            onChange={onExtensaoSearch}
            list="extensoes-list"
            className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
          />
          <datalist id="extensoes-list">
            {extensoes.map((ext) => (
              <option key={ext.idExtensao} value={ext.nome} />
            ))}
          </datalist>
          {searching && filters.extensaoSearch && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2">
              <div className="animate-spin h-4 w-4 border-2 border-green-500 border-t-transparent rounded-full"></div>
            </div>
          )}
        </div>
        <div className="relative">
          <input
            type="text"
            name="idProduto"
            placeholder="ID do Pedido"
            value={filters.idProduto}
            onChange={onChange}
            className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
          />
          {searching && filters.idProduto && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2">
              <div className="animate-spin h-4 w-4 border-2 border-green-500 border-t-transparent rounded-full"></div>
            </div>
          )}
        </div>
        <div className="relative">
          <input
            type="text"
            name="cadastradoPor"
            placeholder="Cadastrado Por"
            value={filters.cadastradoPor}
            onChange={onChange}
            className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
          />
          {searching && filters.cadastradoPor && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2">
              <div className="animate-spin h-4 w-4 border-2 border-green-500 border-t-transparent rounded-full"></div>
            </div>
          )}
        </div>
        <div className="relative">
          <input
            type="text"
            name="user"
            placeholder="Atribuído a"
            value={filters.user}
            onChange={onChange}
            className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
          />
          {searching && filters.user && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2">
              <div className="animate-spin h-4 w-4 border-2 border-green-500 border-t-transparent rounded-full"></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PedidoFilterBar;
